import { render, staticRenderFns } from "./ElectPresident.vue?vue&type=template&id=495c8a44&"
import script from "./ElectPresident.vue?vue&type=script&lang=js&"
export * from "./ElectPresident.vue?vue&type=script&lang=js&"
import style0 from "./ElectPresident.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports